import { hasRecordScope } from '../ir/record-scope';
import type { Gate } from '../ir/types';
import type { RenderContext } from './types';

/** A node without a gate always renders; a field gate that names no record never does. */
export function evaluateGate(gate: Gate | undefined, ctx: RenderContext | null): boolean {
  if (!gate) return true;
  const ability = ctx?.ability;
  if (!ability) return false;
  if (gate.field === undefined) return ability.can(gate.action, gate.subject);
  if (!hasRecordScope(gate.record)) return false;
  return ability.canField(gate.action, gate.subject, gate.field, gate.record);
}
